// TODO use Intl.DateTimeFormat for localized values
export const DAY_NUMBER_TO_I18N: String[] = [
  '',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

type DateValue = Date | string | number;

const naiveToNonNaive = (naive?: DateValue) => {
  if (naive && typeof naive === 'string' && naive.slice(-1).toUpperCase() !== 'Z') {
    return naive + 'Z';
  }
  return naive;
};

export const asDateObj = (value: DateValue) => {
  if (value && typeof value === 'object') {
    return value;
  } else {
    const resolved = naiveToNonNaive(value);
    return resolved ? new Date(resolved) : new Date();
  }
};

export const formatDate = (date: DateValue | null | undefined) => {
  if (!date) {
    return '';
  }
  const dateObj = asDateObj(date);
  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const formatTime = (date: DateValue | null | undefined, showSeconds = false) => {
  if (!date) {
    return '';
  }
  const dateObj = asDateObj(date);
  return dateObj.toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    ...(showSeconds ? { second: '2-digit' } : {}),
  });
};

export const formatDuration = (start: DateValue | null | undefined, end?: DateValue | null) => {
  if (!start) {
    return '';
  }
  const startDateObj = asDateObj(start);
  const endDateObj = asDateObj(end || new Date());
  const diffMs = endDateObj.getTime() - startDateObj.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffSeconds = Math.floor((diffMs % 60000) / 1000);
  if (diffMinutes > 0) {
    return `${diffMinutes}m ${diffSeconds}s`;
  }
  return `${diffSeconds}s`;
};
